<template>
    <v-dialog
        v-model="$store.state.accounting.addExtExpense"
        persistent
        max-width="900px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Add Extra Expense
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.accounting.addExtExpense = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row v-if="toggle">
                    <v-col>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Company</th>
                                    <th>Truck</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ expense.Company }}</td>
                                    <td>{{ expense.Truck }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-combobox
                            v-model="exptype"
                            :items="extexpenses"
                            :item-text="'ExtExpenseType'"
                            :item-value="'ExtExpenseTypeId'"
                            auto-select-first
                            label="Select Extra Expense Type"
                            @change="ChangeCategory"
                            hide-details
                            dense
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12" v-show="parking">
                        <v-combobox
                            v-model="yard"
                            :items="typeYard"
                            :item-text="'yard'"
                            :item-value="'id'"
                            auto-select-first
                            label="Select Yard"
                            @change="calculateParking"
                            hide-details
                            dense
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12" v-show="other">
                        <v-combobox
                            v-model="otherItm"
                            :items="specification"
                            :item-text="'spc'"
                            :item-value="'id'"
                            auto-select-first
                            label="Select Specification"
                            @change="sleSpecification"
                            hide-details
                            dense
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12" v-show="mnl">
                        <v-text-field
                            label="Specification"
                            v-model="manual"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            label="Amount"
                            v-model="amount"
                            hide-details
                            dense
                            @change="calculateTotalHST"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-checkbox
                            label="Taxes"
                            v-model="txs"
                            value="1"
                            dense
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="3">
                        <v-combobox
                            v-model="tax"
                            :items="taxes"
                            :item-text="'text'"
                            :item-value="'id'"
                            auto-select-first
                            label="Select Taxes"
                            @change="calculateTotalHST"
                            v-if="txs"
                            hide-details
                            dense
                        ></v-combobox>
                    </v-col>
                    <v-col cols="2">
                        <v-chip label v-if="txs"
                            >HST/TSP : {{ Number(hst).toFixed(2) }}</v-chip
                        >
                    </v-col>
                    <v-col cols="2">
                        <v-chip label v-if="txs"
                            >QST : {{ Number(qst).toFixed(2) }}</v-chip
                        >
                    </v-col>
                    <v-col cols="2">
                        <v-chip label
                            >Total : {{ Number(total).toFixed(2) }}</v-chip
                        >
                    </v-col>
                    <v-col :cols="'12'" v-if="parking == true">
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th width="40%">Amount</th>
                                    <th width="20%">HST Percent</th>
                                    <th width="20%">HST Total</th>
                                    <th width="20%">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td width="40%">
                                        <v-text-field
                                            v-model="amount"
                                            hide-details
                                            dense
                                        ></v-text-field>
                                    </td>
                                    <td width="20%">
                                        13%
                                    </td>
                                    <td width="20%">
                                        {{ Number(hst).toFixed(2) }}
                                    </td>
                                    <td width="20%">
                                        {{ Number(total).toFixed(2) }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>

                    <v-col cols="12">
                        <v-textarea
                            label="Comment"
                            v-model="comment"
                            hide-details
                            dense
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- <v-col cols="12">
                        Total : <v-chip label>{{total}}</v-chip>
                    </v-col> -->
                    <v-col cols="12">
                        <v-btn
                            class="float-right"
                            color="primary"
                            @click="NewExtExpense"
                            >Save</v-btn
                        >
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['expense', 'select', 'period', 'toggle'],
    data: function() {
        return {
            extexpenses: [],
            exptype: [],
            other: false,
            parking: false,
            manual: null,
            mnl: false,
            total: 0,
            hst: 0,
            qst: 0,
            otherItm: null,
            amount: null,
            dataTruck: null,
            yard: null,
            tax: null,
            txs: false,
            comment: '',
            taxes: [
                { id: 1, text: 'HST' },
                { id: 2, text: 'TSP - QST' }
            ],
            typeYard: [
                { id: 1, yard: 'Upt-Yard' },
                { id: 2, yard: 'Owner-Yard' }
            ],
            specification: [
                { id: 1, spc: 'Rental Truck Charges/ Kms ' },
                { id: 2, spc: 'Repairs' },
                { id: 3, spc: 'Manual Specification' }
            ]
        };
    },
    mounted() {
        console.log(this.expense);
        this.loadExtTypes();
        if (this.toggle) {
            this.loadTruckData();
        }
    },
    methods: {
        calculateTotalHST: function() {
            this.qst = 0;
            this.hst = 0;
            if (this.tax != null) {
                if (this.tax.id == 1) {
                    this.hst = Number(this.amount * 0.13);
                    this.total = Number(
                        Number(this.amount * 0.13) + Number(this.amount)
                    ).toFixed(2);
                } else if (this.tax.id == 2) {
                    this.qst = Number(this.amount * 0.09975);
                    this.hst = Number(this.amount * 0.05);
                    this.total = Number(
                        Number(this.amount * 0.05) +
                            +Number(this.amount * 0.09975) +
                            Number(this.amount)
                    ).toFixed(2);
                } else {
                    this.total = Number(this.amount).toFixed(2);
                }
            } else {
                this.total = Number(this.amount).toFixed(2);
            }
        },
        ChangeCategory: function() {
            this.parking = false;
            this.other = false;
            this.otherItm = null;
            this.hst = null;
            this.total = null;
            this.yard = null;
            console.log(this.exptype.ExtExpenseTypeId, this.dataTruck);
            switch (this.exptype.ExtExpenseTypeId) {
                case 1:
                    this.amount = this.dataTruck.AdminFee;
                    break;
                case 2:
                    this.amount = this.dataTruck.Holdback;
                    break;
                case 3:
                    this.amount = this.dataTruck.MaintHoldback;
                    break;
                case 4:
                    this.parking = true;
                    this.other = false;
                    this.amount = 0;
                    break;
                default:
                    this.parking = false;
                    this.amount = 0;
                    this.other = true;
                    break;
            }
        },
        calculateParking: function() {
            this.amount = this.dataTruck.Parking;
            if (this.yard.id != 1) {
                this.hst = Number(this.amount) * 0.13;
                this.total = Number(this.hst) + Number(this.amount);
            } else {
                this.hst = Number(this.amount) * 0.13 * -1;
                this.amount = Number(this.amount) * -1;
                this.total = this.hst + this.amount;
            }
        },
        calculateTotals: function() {
            if (this.yard.id != 1) {
                this.hst = Number(this.amount) * 0.13;
                this.total = Number(this.hst) + Number(this.amount);
            } else {
                if (this.amount > 0) {
                    this.amount = Number(this.amount) * -1;
                    this.hst = Number(this.amount) * 0.13 * -1;
                } else {
                    this.hst = Number(this.amount) * 0.13;
                }
                this.total = Number(this.hst) + Number(this.amount);
            }
        },
        loadExtTypes: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('ext-expenses-type')
                .then(response => {
                    this.extexpenses = response.data.filter(x => {
                        return x.ExtExpenseTypeId == 5;
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        NewExtExpense: function() {
            var str = this.$store;
            var parms = {
                Amount: this.amount,
                HST: this.hst,
                QST: this.qst,
                TruckId: this.expense.TruckID,
                PayDate: this.expense.Date,
                idExtType: this.exptype.ExtExpenseTypeId,
                PeriodComment: this.comment,
                Stmt: this.expense.STMT,
                Total: this.total
            };
            if (this.otherItm.id == 3) {
                parms.Specification = this.manual;
            } else {
                parms.Specification = this.otherItm.spc;
            }
            console.log(parms);
            // console.log(this.other,this.parking);
            // if(this.other == false && this.parking == false){
            //     parms.Total = this.hst === true ?  Number((this.amount * .13)) + Number((this.amount)) : Number(this.amount);
            // }else if(this.other == true || this.parking == false){
            //
            //     parms.Total = this.hst === true ?  Number((this.amount * .13)) + Number((this.amount)) : Number(this.amount);
            // }else if(this.other == false || this.parking == true){
            //     parms.Specification = this.yard.yard;
            //     parms.Total = this.hst === true ?  Number((this.amount * .13)) + Number((this.amount)) : Number(this.amount);
            // }
            str.state.isLoading = true;
            if (!this.select) {
                parms.EfectiveDateStart = this.$store.state.getMsk('StartDate');
                parms.EfectiveDateEnd = this.$store.state.getMsk('EndDate');
            } else {
                parms.EfectiveDateStart = this.period['EfectiveDateStart'];
                parms.EfectiveDateEnd = this.period['EfectiveDateEnd'];
            }
            parms.ChargeType = this.toggle;
            axios
                .post('ext-expense', parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Extra Expenses successfully saved'
                    });
                    this.$emit('close');
                    str.state.isLoading = false;
                    this.$store.state.accounting.addExtExpense = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        sleSpecification: function() {
            this.mnl = false;
            if (this.otherItm.id == 3) {
                this.mnl = true;
            }
        },
        loadTruckData: function() {
            var str = this.$store;
            axios
                .get('truck/' + this.expense.TruckID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.dataTruck = response.data.data[0];
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        }
    }
};
</script>
